import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class InputComponent {
  // todo samuel: duplicate code with currency input component

  @Input()
  label?: string;

  hasErrors = false;

  @Input()
  set errors(errors: ValidationErrors | null | undefined) {}
}
